"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var times_1 = (0, tslib_1.__importDefault)(require("lodash/times"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var flexbox_1 = require("../../flexbox");
var icon_button_1 = require("../../icon-button");
var padding_1 = require("../../padding");
var select_1 = require("./select");
var formatter = new Intl.DateTimeFormat(undefined, { month: 'long' });
function CalendarHeader(props) {
    var maxYear = props.maxYear, minYear = props.minYear, calendarHook = props.calendarHook;
    var increaseMonth = calendarHook.increaseMonth, decreaseMonth = calendarHook.decreaseMonth, setYear = calendarHook.setYear, setMonth = calendarHook.setMonth, year = calendarHook.year, month = calendarHook.month;
    return (react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "space-between", alignItems: "center", width: "100%" },
        react_1.default.createElement(flexbox_1.FlexCell, null,
            react_1.default.createElement(icon_button_1.IconButton, { type: "chevronLeft", onClick: decreaseMonth })),
        react_1.default.createElement(flexbox_1.FlexCell, { flex: 1 },
            react_1.default.createElement(padding_1.Padding, { x: 4 },
                react_1.default.createElement(flexbox_1.Flexbox, { width: "100%" },
                    react_1.default.createElement(padding_1.Padding, { right: 4, style: { flex: '1.5' } },
                        react_1.default.createElement(select_1.Select, { minWidth: "100px", value: String(month), onChange: function (month) { return setMonth(parseInt(month, 10)); } }, (0, times_1.default)(12, function (num) {
                            return react_1.default.createElement("option", { value: num + 1 }, formatter.format(new Date().setMonth(num)));
                        }))),
                    react_1.default.createElement("div", { style: { flex: '1' } },
                        react_1.default.createElement(select_1.YearInput, { value: year, onChange: setYear, minYear: minYear, maxYear: maxYear }))))),
        react_1.default.createElement(flexbox_1.FlexCell, null,
            react_1.default.createElement(icon_button_1.IconButton, { type: "chevronRight", onClick: increaseMonth }))));
}
exports.default = CalendarHeader;
//# sourceMappingURL=header.js.map